
import React, { useEffect, useState, useMemo } from "react";
import { parsedUser } from "../../common/GetCurrentUser";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    PointElement,
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import API from "../../common/API";
import moment from "moment";
import { Col, Row } from "react-bootstrap";
import { getRandomColor } from "../../common/helpers";



// Registrar ChartJS una sola vez fuera del componente
ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    BarElement,
    Title,
    Tooltip,
    Legend
);


interface FranchiseRecord {
    date: string;
    franchiseValues: any[];
}

const TotalFranchiseMonthly: React.FC = () => {
    const [from, setFrom] = useState<string>(moment().add(-1, 'years').format('YYYY-MM-DD'));
    const [to, setTo] = useState<string>(moment().format('YYYY-MM-DD'));
    const [records, setRecords] = useState<FranchiseRecord[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const user = parsedUser();

    // Dataset para ChartJS, memoizado
    const chartData = useMemo(() => {
        if (!records || records.length === 0) return null;
        console.log(records)


        let eachFranchise = records[0].franchiseValues.map((item: any) => {
            console.log(item);
            return item.franchiseName
        });
        let franchiseDataSet: any[] = [];
        console.log(eachFranchise)
        eachFranchise.forEach((item: string, index: number) => {
            let dataset: any = {
                label: item,
                data: [],
                backgroundColor: getRandomColor()
            }

            records.forEach((record: any) => {
                let franchiseValue = record.franchiseValues.find((f: any) => f.franchiseName === item);
                dataset.data.push(franchiseValue ? franchiseValue.value : 0);
            });

            franchiseDataSet.push(dataset);
        });

        return {
            labels: records.map(item => moment(item.date).format('MMM, YYYY')),
            datasets: franchiseDataSet,
        };
    }, [records]);

    const options = useMemo(() => ({
        responsive: true,
        plugins: {
            legend: {
                position: "top" as const,
            },
            title: {
                display: false,
                text: "Total Purchased",
            },
        },
    }), []);

    // Fetch data
    const bindDataRemote = async () => {
        if (!user?.OrganizationId) return;
        setLoading(true);
        try {
            const query = `organizationId=${user.OrganizationId}&from=${from}&to=${to}`;
            const request = await API.getAction(`franchise/TotalMonthly?${query}`);
            setRecords(Array.isArray(request.data.response) ? request.data.response : []);
        } catch (err) {
            setRecords([]);
            // Aquí podrías usar toast.error('Error al cargar datos')
        } finally {
            setLoading(false);
        }
    };

    // Solo un efecto para fetch (evita doble llamada)
    useEffect(() => {
        bindDataRemote();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [from, to, user?.OrganizationId]);

    if (loading) {
        return <div className="text-center my-4">Cargando datos...</div>;
    }
    if (!chartData) {
        return <div className="text-center my-4">Sin datos</div>;
    }

    return (
        <div className="card shadow-sm mb-2">
            <div className="card-header">
                <Row>
                    <Col>
                        <span className="display-6 d-inline text-uppercase">Historico de Franquicia</span>
                    </Col>
                    <Col className="text-end">
                        <div className="input-group">
                            <input type="date" value={from} onChange={e => setFrom(e.target.value)} className="form-control" />
                            <input type="date" value={to} onChange={e => setTo(e.target.value)} className="form-control" />
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="card-body">
                <Line options={options} data={chartData} />
            </div>
            {/* <Card.Footer>
                <h4>Total: {FormatMoney(records.reduce((a, b) => a + b.value, 0))} gl</h4>
            </Card.Footer> */}
        </div>
    );
};

export default TotalFranchiseMonthly;